import type { ReactNode } from 'react';
import { DSCard, DSTypography } from '@eiv2/design-system';

export interface SectionCardProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function SectionCard({ title, subtitle, action, children }: SectionCardProps) {
  return (
    <DSCard className="shadow-[0_8px_32px_oklch(0.2101_0.0318_264.66_/_0.06)]">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <DSTypography as="h2" className="text-[18px] font-semibold text-dark-3">
            {title}
          </DSTypography>
          {subtitle ? (
            <DSTypography as="p" className="mt-1 text-[13px] font-normal text-gray-5">
              {subtitle}
            </DSTypography>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
      {children}
    </DSCard>
  );
}
